import { render, staticRenderFns } from "./PreviewEventCreation.vue?vue&type=template&id=45d6364c&scoped=true&lang=pug"
import script from "./PreviewEventCreation.vue?vue&type=script&lang=js"
export * from "./PreviewEventCreation.vue?vue&type=script&lang=js"
import style0 from "./PreviewEventCreation.vue?vue&type=style&index=0&id=45d6364c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6364c",
  null
  
)

export default component.exports